import { inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    Router,
    RouterStateSnapshot,
} from '@angular/router';
import { AuthUtilsService, MetaService, PlatformService } from '@common/services';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

export const isAuthorized: CanActivateFn = (
    routeSnapshot: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    authUtilsService = inject(AuthUtilsService),
    router = inject(Router),
    platformService = inject(PlatformService),
    metaService = inject(MetaService)
) => {
    if (platformService.isServer) return of(true);
    return authUtilsService.userForAuthGuard$().pipe(
        switchMap((user) => {
            const redirect = authUtilsService.determineRedirect(user, state.url, true);
            if (redirect) {
                router.navigate([redirect.url], { queryParams: redirect.queryParams });
                return of(false);
            }
            return of(true);
        }),
        catchError(() => {
            if (metaService.isPublic(routeSnapshot.data.dynamicRouteDataKey || state.url)) {
                return of(true);
            }

            const { userid, passwordresettoken } = routeSnapshot.queryParams;

            authUtilsService.redirectURL = {
                url: state.url.replace(/\?.*$/, ''),
                queryParams: state.root.queryParams,
            };

            if (userid && passwordresettoken) {
                return authUtilsService
                    .resetTokenValid$({
                        userId: userid,
                        passwordResetToken: passwordresettoken,
                    })
                    .pipe(
                        switchMap((response) => {
                            if (response.valid) {
                                router.navigate([
                                    `/auth/password-reset/${userid}/${passwordresettoken}`,
                                ]);
                            } else {
                                router.navigate(['/auth/login']);
                            }
                            return of(false);
                        })
                    );
            } else {
                router.navigate(['/auth/login']);
            }

            return of(false);
        })
    );
};
